import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import keyCodes from '../../../constants/keycodes';
import { Box } from '../../layout/Box';
import { Icon, IconCaretDown, IconCaretUp } from '../../imagesAndIcons/Icon';
import { Size } from './types';
import { Text } from '../../typography/Text';
import { DropdownContainer, DropdownHandle, DropdownHandleDiv } from './styled-components';
import getDocument from '../../../utilities/get-document';
import parentIncludesEventTarget from '../../../utilities/parentIncludesEventTarget';
import * as _CSS from '../../../types/css';
import { DropdownList } from './DropdownList';
import { filterForAriaProps } from '../../../utilities/accessibility';
export var DROPDOWN_PADDING = 2;
var document = getDocument();

var Dropdown =
/** @class */
function (_super) {
  __extends(Dropdown, _super);

  function Dropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      closingTimeoutId: null
    };
    _this.childrenWrapper = React.createRef();
    _this.menuToggleDiv = React.createRef();

    _this.handleKeyDown = function (e) {
      var _a = _this.props,
          closeOnOutsideClick = _a.closeOnOutsideClick,
          isOpen = _a.isOpen,
          onClose = _a.onClose;

      if (!closeOnOutsideClick) {
        return;
      }

      if (isOpen && e.key === keyCodes.ESC && onClose) {
        onClose(e);
      }
    };

    _this.handleMouseClickOutside = function (e) {
      var _a = _this.props,
          closeOnOutsideClick = _a.closeOnOutsideClick,
          onClose = _a.onClose;

      if (!closeOnOutsideClick || !onClose) {
        return;
      } // We also want to consider clicks on the toggle div as 'inside' clicks
      // so we don't preempt onClick's call of this.props.onClose


      if (parentIncludesEventTarget(e, _this.childrenWrapper.current) || parentIncludesEventTarget(e, _this.menuToggleDiv.current)) {
        return;
      }

      e.stopPropagation();
      onClose(e);
    };

    _this.toggleMenuShowing = function (e) {
      var _a = _this.props,
          onOpen = _a.onOpen,
          onClose = _a.onClose,
          isOpen = _a.isOpen;

      if (!isOpen && onOpen) {
        onOpen(e);
      } else if (isOpen && onClose) {
        onClose(e);
      }
    };

    _this.renderDisplayValue = function () {
      var _a = _this.props,
          disabled = _a.disabled,
          dropdownHandle = _a.dropdownHandle;
      var displayValue = _this.props.displayValue || _this.props.placeholder;
      return typeof displayValue === 'string' && !dropdownHandle ? React.createElement(Text, {
        color: disabled ? Text.Color.Gray3 : Text.Color.Dark
      }, displayValue) : displayValue;
    };

    _this.renderHandleContent = function () {
      var _a = _this.props,
          hideCaret = _a.hideCaret,
          isOpen = _a.isOpen;
      var caretProps = {
        color: _this.props.disabled ? Icon.Color.Gray3 : Icon.Color.Gray1,
        size: Icon.Size.Xxs
      };
      var caret = isOpen ? React.createElement(IconCaretUp, __assign({}, caretProps)) : React.createElement(IconCaretDown, __assign({}, caretProps));
      return React.createElement(Box, {
        alignContent: Box.AlignContent.Center,
        alignItems: Box.AlignItems.FlexStart,
        display: Box.Display.Flex,
        flexDirection: Box.FlexDirection.Row,
        flexWrap: Box.FlexWrap.NoWrap,
        justifyContent: Box.JustifyContent.SpaceBetween
      }, React.createElement(Box, {
        mr: hideCaret ? 0 : 1.5
      }, _this.renderDisplayValue()), !hideCaret && caret);
    };

    _this.renderHeader = function () {
      var header = _this.props.header;
      return React.createElement(Box, {
        pb: DROPDOWN_PADDING + 1
      }, React.createElement(Text, {
        color: Text.Color.Gray2,
        el: Text.Element.P,
        noMargin: true
      }, header));
    };

    _this.handleMouseOverHandle = function (e) {
      var _a = _this.props,
          openOnHover = _a.openOnHover,
          onOpen = _a.onOpen,
          isOpen = _a.isOpen;

      if (openOnHover && onOpen && !isOpen) {
        onOpen(e);
      }
    };

    _this.handleMouseLeave = function (e) {
      var _a = _this.props,
          openOnHover = _a.openOnHover,
          isOpen = _a.isOpen,
          onClose = _a.onClose;

      if (!openOnHover || !isOpen || !onClose || _this.isMouseEventInHitbox(e)) {
        return;
      }

      e.stopPropagation();
      onClose(e);
    };

    return _this;
  }

  Dropdown.prototype.componentDidMount = function () {
    document.addEventListener('keydown', this.handleKeyDown);

    if (this.props.onClose) {
      document.addEventListener('mousedown', this.handleMouseClickOutside);
    }
  };

  Dropdown.prototype.componentWillUnmount = function () {
    document.removeEventListener('keydown', this.handleKeyDown);

    if (this.props.onClose) {
      document.removeEventListener('mousedown', this.handleMouseClickOutside);
    }
  };

  Object.defineProperty(Dropdown.prototype, "handleHitbox", {
    get: function get() {
      var handleTarget = this.menuToggleDiv.current;

      if (!handleTarget) {
        return null;
      }

      var h = handleTarget.getBoundingClientRect();
      return {
        left: Math.floor(h.left),
        right: Math.floor(h.right),
        top: Math.floor(h.top),
        bottom: Math.floor(h.bottom)
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Dropdown.prototype, "containerHitbox", {
    get: function get() {
      var containerTarget = this.childrenWrapper.current;

      if (!containerTarget) {
        return null;
      }

      var c = containerTarget.getBoundingClientRect();
      return {
        left: Math.floor(c.left),
        right: Math.floor(c.right),
        top: Math.floor(c.top),
        bottom: Math.floor(c.bottom)
      };
    },
    enumerable: true,
    configurable: true
  });

  Dropdown.prototype.render = function () {
    var _a = this.props,
        ariaLabel = _a.ariaLabel,
        children = _a.children,
        disabled = _a.disabled,
        handleComponent = _a.dropdownHandle,
        fluidWidth = _a.fluidWidth,
        header = _a.header,
        id = _a.id,
        isDivDropdown = _a.isDivDropdown,
        isOpen = _a.isOpen,
        maxHeight = _a.maxHeight,
        minWidth = _a.minWidth,
        noHandleStyle = _a.noHandleStyle,
        openOnHover = _a.openOnHover,
        rightAlign = _a.rightAlign,
        width = _a.width,
        restProps = __rest(_a, ["ariaLabel", "children", "disabled", "dropdownHandle", "fluidWidth", "header", "id", "isDivDropdown", "isOpen", "maxHeight", "minWidth", "noHandleStyle", "openOnHover", "rightAlign", "width"]);

    var handleContent = this.renderHandleContent();

    if (handleComponent) {
      handleContent = React.createElement(handleComponent.component, handleComponent.props, handleContent);
    }

    var dropdownHandleProps = __assign({
      'aria-expanded': isOpen,
      'aria-haspopup': true,
      'aria-label': ariaLabel,
      'data-tag': 'menuToggleDiv',
      disabled: disabled,
      fluidWidth: fluidWidth,
      hasCustomHandle: !!handleComponent || noHandleStyle,
      id: id,
      isOpen: isOpen,
      minWidth: minWidth,
      onMouseOver: openOnHover ? this.handleMouseOverHandle : undefined,
      openOnHover: openOnHover,
      ref: this.menuToggleDiv
    }, filterForAriaProps(restProps));

    return React.createElement(Box, {
      alignSelf: Box.AlignSelf.Center,
      fluidWidth: fluidWidth,
      onMouseLeave: this.handleMouseLeave,
      position: Box.Position.Relative
    }, isDivDropdown ? React.createElement(DropdownHandleDiv, __assign({}, dropdownHandleProps), handleContent) : React.createElement(DropdownHandle, __assign({}, dropdownHandleProps, {
      onClick: !disabled ? this.toggleMenuShowing : undefined
    }), handleContent), isOpen && React.createElement(DropdownContainer, {
      "data-tag": "dropdown-list",
      ref: this.childrenWrapper,
      rightAlign: rightAlign,
      maxHeight: maxHeight,
      width: width
    }, React.createElement(Box, {
      p: DROPDOWN_PADDING
    }, header && this.renderHeader(), children)));
  };

  Dropdown.prototype.isMouseEventInHitbox = function (e) {
    if (!this.handleHitbox || !this.containerHitbox) {
      return false;
    }
    /**
     * If within handle hitbox (+ height of menu for gap b/w both)
     */


    if (e.clientX > this.handleHitbox.left && e.clientX < this.handleHitbox.right && e.clientY > this.handleHitbox.top && e.clientY < this.containerHitbox.bottom) {
      return true;
    }
    /**
     * If within container hitbox
     */


    if (e.clientX > this.containerHitbox.left && e.clientX < this.containerHitbox.right && e.clientY > this.containerHitbox.top && e.clientY < this.containerHitbox.bottom) {
      return true;
    }

    return false;
  };

  Dropdown.List = DropdownList;
  Dropdown.Size = Size;
  Dropdown.Width = _CSS.Width;
  Dropdown.MaxHeight = _CSS.MaxHeight;
  Dropdown.defaultProps = {
    closeOnOutsideClick: true,
    placeholder: 'Select…',
    hideCaret: false,
    isDivDropdown: false,
    width: _CSS.Width.Auto,
    maxHeight: _CSS.MaxHeight.None
  };
  return Dropdown;
}(React.Component);

export { Dropdown };